import React from 'react';
import MainArea from '../components/MainArea';

const ListPage = () => {
  return (
    <div >
       {/*1st page -  Home page */}
      <MainArea/>
    </div>
  );
};

export default ListPage;
